module.exports = __webpack_public_path__ + "img/customer-page-en.1daa217a.png";